define(['underscore', 'edge/platform/base/BaseCtrl'], (_, BaseCtrl)=> {
    const fn = ($filter, $scope, $rootScope, $translate, $anchorScroll, ModalService, StateUtils, submissionViewModel,InMemorySession,InputValidationService)=> {
        const ctrl = Object.create(BaseCtrl);
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        const submissionVm = submissionViewModel()
        //adding a listener function that will be called while navigating from one Step to another
        flowModel.addStepChangeListener(deleteCorruptNode)
        const paModel = submissionVm.draftData.lobs.personalAuto.value;
        const accountHolder = submissionVm.value.getAccountHolderPerson();
        $scope.currentPageName = flowModel.currentStep.name;
        const flowSteps = flowModel.steps;
        const currentStepIndex = _.findIndex(flowSteps, step => step.name === flowModel.currentStep.name);
        //ENHC0013007 -- Insurance Premium Refunds --Arpita
        $scope.isNameValid = true
        //ended
        //This method will delete any invalid driver node from model
        //when navigating from the driver's page using Wizard menu and NOT next button
        //Currently checking for both Driver and vehicle node coming from prefill service


        function deleteCorruptNode(model, fromStep,goingToStep){
            var goingToStepIndex = _.findIndex(flowSteps, step => step.name === goingToStep.name);
            var isGoingNextPage = goingToStepIndex === currentStepIndex+1;
            if($scope.currentPageName === fromStep.name && !isGoingNextPage){
                //validate all the drivers that are in viewmodel
                var corruptedDrivers = [];
                var drivers = model.draftData.lobs.personalAuto.drivers;
                if(typeof drivers != 'undefined' && drivers.length > 0){
                   _.forEach(drivers,function(item,index){
                      if(!drivers.getElement(index).aspects.subtreeValid){
                          corruptedDrivers.push(drivers.getElement(index).value);
                      }
                   });
                }

                _.forEach(corruptedDrivers,function(driver){
                    model.draftData.lobs.personalAuto.value.removeDriver(driver);
                });


                //remove the vehicles also if all the drivers are removed
                //validating vehicle node
                if( model.draftData.lobs.personalAuto.drivers.length === 0){
                    model.draftData.lobs.personalAuto.vehicles.value = [];
                }
                var corruptedVehicles = [];
                var vehicles = model.draftData.lobs.personalAuto.vehicles;
                if(typeof vehicles != 'undefined' && vehicles.length > 0){
                    _.forEach(vehicles,function(item,index){
                        if(!vehicles.getElement(index).aspects.subtreeValid){
                            corruptedVehicles.push(vehicles.getElement(index).value);
                        }
                    });
                }

                _.forEach(corruptedVehicles,function(vehicle){
                    model.draftData.lobs.personalAuto.value.removeVehicle(vehicle);
                });
            }

        }

        function validateInputs (inputsToValidate, scopeVar) {
            let inputValidationData = [];
            inputValidationData = InputValidationService.isInputValid(inputsToValidate)
            if(!inputValidationData[0] && inputValidationData[1].length > 0){
                for (let i=0; i<inputValidationData[1].length; i++){
                    scopeVar[inputValidationData[1][i]] = ''
                    $scope.isNameValid = false;
                }
            }else{
                $scope.isNameValid = true;
            }
        }

        ctrl.init = ()=> {
            var prefillResponseFromFactory = InMemorySession.getPrefillData();
            // Scroll to top of page onload
            $anchorScroll();

            // State Code for account holder
            $scope.accountHolder = accountHolder;
            
            // Fill prefill vehicles
            var prefillVehicles = [];
            if(paModel.vehicles && paModel.vehicles.length > 0){
                for(var idx in  paModel.vehicles){
                    if(paModel.vehicles[idx]["isPrefilledVehicle"] == true){
                        prefillVehicles.push(paModel.vehicles[idx]);
                    }
                }
            }            
            //devendra prefill code started
            if(paModel.drivers && paModel.drivers.length > 0 && prefillResponseFromFactory && typeof prefillResponseFromFactory.drivers !== "undefined"){
                for(let idxDriver in  paModel.drivers){
                    paModel.drivers[parseInt(idxDriver)].hasPrefilledLicenseNumber = false
                    if (paModel.drivers[parseInt(idxDriver)].eNCLicenseNumber != "undefined" && paModel.drivers[parseInt(idxDriver)].eNCLicenseNumber != '') {
                        paModel.drivers[parseInt(idxDriver)].hasPrefilledLicenseNumber = true 
                    }
                    if(typeof paModel.drivers[parseInt(idxDriver)] != "undefined" && prefillResponseFromFactory.drivers.length > 0){
                        $scope.prefillDriverCheck(paModel.drivers[idxDriver],parseInt(idxDriver),prefillResponseFromFactory);
                    }
                }
            }
            //devendra prefill code end
            $scope.$filter = $filter;
            $scope.page = {
                drivers: paModel.drivers,
                prefillVehicles: prefillVehicles,
                vehicles: paModel.vehicles,
            };
                        
            let currentDriver;
            if (paModel.drivers.length === 0) { //If there are no drivers and this is the first visit, initialise a new driver
                currentDriver = paModel.createDriver(accountHolder); 
            } else { //Select account holder
                //This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
                const sanitisePrefillDataFromQuickQuote = (driver) => {
                    if (driver.licenseNumber === '0streamlinedquote0') {
                        driver.licenseNumber = undefined;
                        driver.yearLicensed = undefined;
                        driver.gender = undefined;
                       
                    }
                };
                currentDriver = paModel.getDriverForPerson(accountHolder);
                sanitisePrefillDataFromQuickQuote(currentDriver);
            }
            /* ENHC0011961_EODB QnB Defaults - defaulting licensed age for first driver -- Arpita Sengupta */
            if (paModel.drivers.length <= 1){
                currentDriver.firstLicensed = "16"
            }
            //ended
            $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(currentDriver);
                     
            // added below code for getting age *Princy
            $scope.age= $scope.getAge($scope.page.currentDriver.dateOfBirth);
            

            //submissionVm.draftData.lobs.personalAuto.drivers.forEach(driver -> driver.age = getAge(driver.dateofBirth))
            //added code for drivers DOB *Princy
            submissionVm.draftData.lobs.personalAuto.drivers.forEach((driver)=> {
                if(driver.dateofBirth != undefined){
                    $scope.age = $scope.getAge(driver.dateofBirth);
                }
            });

            //$scope.page.currentDriver.relationShipToYou.value = "Spouse";
            //console.log("RelationShip: ", $scope.page.currentDriver.relationShipToYou.value);
        };

        // *Princy*
        $scope.getAge = function(localDate) {
            
            var year = parseInt(localDate.year);
            if(isNaN(year))return '';
            var month = parseInt(localDate.month) - 1;
            var day = parseInt(localDate.day);
            var today = new Date();
            var birthDate = new Date(year,month,day);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age ? age: null;
        };
        //devendra prefill code started
        $scope.prefillDriverCheck = function(driver,index,prefillResponseFromFactory){
            let isPrefilledDriverCheck = false;
            if(prefillResponseFromFactory && prefillResponseFromFactory.drivers){
                prefillResponseFromFactory.drivers.forEach((obj) => {
                    if(driver.person.firstName !== "undefined" && obj.dateOfBirth){
                        let d1 = {};
                        if(driver.dateOfBirth){
                            d1 = new Date(driver.dateOfBirth.year, driver.dateOfBirth.month, driver.dateOfBirth.day);
                        }else if(driver.eNCDateOfBirth){
                            let encDob = InMemorySession.decryptData(driver.eNCDateOfBirth).split(' ')[0].split("-")
                            d1 = new Date(encDob[0], encDob[1]-1, encDob[2]);
                        }
                        let d2 = obj.dateOfBirth;
                        d2.setHours(0, 0, 0, 0);
                        if(driver.person.firstName.toLowerCase() == obj.firstName.toLowerCase() && driver.person.lastName.toLowerCase() == obj.lastName.toLowerCase() && d1.getTime() == d2.getTime()){
                            //prefill --Arpita
                            paModel.drivers[index].eNCGender = paModel.drivers[index].eNCGender? paModel.drivers[index].eNCGender : paModel.drivers[index].gender ;

                            paModel.drivers[index].eNCDateOfBirth = paModel.drivers[index].eNCDateOfBirth? paModel.drivers[index].eNCDateOfBirth : paModel.drivers[index].dateOfBirth ;
                            //DFCT0019638 - added condition when giving random data and drivers have 1 prefilled and other non prefilled and license no for prefilled is not present - Arpita
                            paModel.drivers[index].eNCLicenseNumber = paModel.drivers[index].eNCLicenseNumber? paModel.drivers[index].eNCLicenseNumber : ((!InMemorySession.decryptData(paModel.drivers[index].licenseNumber) && paModel.drivers[index].licenseNumber) ?  InMemorySession.encryptData(paModel.drivers[index].licenseNumber).toString() : paModel.drivers[index].licenseNumber);
                            //ended
                            
                            paModel.drivers[index].eNCLicenseState = paModel.drivers[index].eNCLicenseState? paModel.drivers[index].eNCLicenseState : paModel.drivers[index].licenseState ;
                            paModel.drivers[index].licenseNumber = null;
                            paModel.drivers[index].gender = null;
                            paModel.drivers[index].licenseState = null;

                            isPrefilledDriverCheck = true;
                        }
                    }                           
                });
            }
            if(isPrefilledDriverCheck){
                paModel.drivers[index].isPrefilledDriver = true;
            }else{
                paModel.drivers[index].isPrefilledDriver = false;
            }
        };
        //devendra prefill code end

        ctrl.isDriverValid = ()=> {
            return $scope.page.currentDriver.aspects.subtreeValid;
        };

        ctrl.addDriver = (form)=> {
            if (ctrl._isValid(form)) {
                $anchorScroll();
                //ENHC0013007 -- Insurance Premium Refunds --Arpita
                //security vulnerabilities
                let inputsToValidate = [
                    {'firstName' : $scope.page.currentDriver.value.person.firstName},
                    {'middleName' : $scope.page.currentDriver.value.person.middleName},
                    {'lastName' : $scope.page.currentDriver.value.person.lastName}
                ];
                validateInputs(inputsToValidate, $scope.page.currentDriver.value.person)
                if(!$scope.isNameValid){
                    return
                }
                //ended
                const paddr = submissionVm.draftData.policyAddress.value;
                const newPerson = submissionVm.value.createPerson({
                    primaryAddress: paddr
                });
                /* ENHC0011961_EODB QnB Defaults - defaulting state while adding driver -- Arpita Sengupta */
                newPerson.primaryAddress= {
                    state : paddr.state
                };
                //ended
                const newDriver = paModel.createDriver(newPerson);

                $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(newDriver);
                 /**
             * Defect : DFCT0016955 - GPA – SC Auto Date First Licensed Rules no Longer Working (reference CHG00328640)
             * Developer : Devnandan Kumar*/
                  if ($scope.page.currentDriver.accountHolderState.value.code === 'SC') {
                    $scope.page.currentDriver.minAge.value = 15;
                }
                else {
                    $scope.page.currentDriver.minAge.value = 16;
                }
                $scope.$broadcast('update-form');
                form.submitted = false;
                form.setPristine();
            }
            else{
                
                form.submitted = true;
                if (!ctrl._isValid() || form.valid === false) {
                    return;
                }   
            }
        };

        ctrl.editDriver = (driver, form, rowIndex)=> { //Validate the current input, and if correct, save the current changes and select the next driver
            $scope.selectedRow = rowIndex;

            if (ctrl._isValid(form)) {
                $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(driver);
                if(typeof $scope.currentDriver != 'undefined'){
                    $scope.age= $scope.getAge($scope.currentDriver.dateOfBirth.value); //age functionality call *Princy
                }else{
                    $scope.age= null;
                }
                //console.log($scope.age);
            }
            else{

                form.submitted = true;
                if (!ctrl._isValid() || form.valid === false) {
                    return;
                }
            }
        };

        ctrl.removeDriver = (driver)=> {
            const msg = {
                key: 'quoteandbind.pa.controllers.PADriverDetailsCtrl.DriverRemovalMsg',
                args: {driver: driver.getDisplayName(undefined, $filter)}
            };
            ModalService.showWarning(
                'quoteandbind.pa.controllers.PADriverDetailsCtrl.Remove driver?', msg, '',
                $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.Yes'), 'gw-btn-primary',
                $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.No'))
                .result.then(()=> {
                //If block commented by IN010M58288 for production issue raised by Vijay Mallik Reddy
                /*if (driver === $scope.page.currentDriver.value) {
                    $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(paModel.drivers[0]);
                }*/
                // Start Below code added by IN010M58288 for production issue raised by Vijay Mallik Reddy
                                let driverObj;
                                                if (submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(driver) === $scope.page.currentDriver) { //If we're about to delete the current vehicle, show the first vehicle or blank
                                                    if (paModel.drivers.length > 1) {
                                                        if (paModel.drivers[0] !== driver) {
                                                            driverObj = paModel.drivers[0];
                                                        } else {
                                                            driverObj = paModel.drivers[1];
                                                        }
                                                    }
                                                } else {
                                                    driverObj = $scope.page.currentDriver.value;
                                                }
                               // End Below code added by IN010M58288 for production issue raised by Vijay Mallik Reddy
                paModel.removeDriver(driver);
                $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(driverObj); // Added by IN010M58288 for production issue raised by Vijay Mallik Reddy
                $scope.$broadcast('update-form');
            });
        };

        ctrl._isValid = ()=> {
            if (!ctrl.isDriverValid()) {
                return false;
            }
            
            //console.log("_isAddAccidentValid:: ",$scope.page.currentDriver.value.accidentsInLast3Years, $scope.page.currentDriver.value.accidentVoilationList.length);
            
            // Check if accident/ claim summary selected and with no accident / claim summary is defined
            if($scope.page.currentDriver.value.accidentsInLast3Years == true 
                    && $scope.page.currentDriver.value.accidentVoilationList.length == 0){
                ModalService.showWarning('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Please specify the type and date of the event");
                
                return false;
            }
            
            const licenceMatchedDriver = ctrl._ensureUniqueLicenseNumber($scope.page.currentDriver.value);
            if (licenceMatchedDriver) {
                const msg = $translate('quoteandbind.pa.controllers.PADriverDetailsCtrl.LicenceMatchMsg', {driver: licenceMatchedDriver.getDisplayName(undefined, $filter)});
                ModalService.showWarning('quoteandbind.pa.controllers.PADriverDetailsCtrl.Licence number is not unique', msg);

                return false;
            }
            return true;
        };

        ctrl._ensureUniqueLicenseNumber = (driver)=> {
            const driverMatch = _.where(paModel.drivers, {licenseNumber: driver.licenseNumber});
            if (!driverMatch) {
                return undefined;
            } else if (driverMatch.length === 1) {
                return driverMatch[0] !== driver ? driverMatch : undefined;
            }
            return _.find(driverMatch, (d)=> {
                    if(d.licenseNumber !="" && d.licenseNumber != undefined){
                    return d !== driver;
            }

            });
        };
        
        // Find Primary Driver
        ctrl.findPrimaryDriver = function(){
            
            var drivers = submissionVm.value.draftData.lobs.personalAuto.drivers;
                   
            for (var idx in drivers){
                var driver = drivers[idx];
                if(driver.person.accountHolder){
                    return driver;
                }
            }
        };
        
        // Validate spouse is selected for primary insurer if he is married
        ctrl.validateSpouse = function(){
            
            var primaryDriver = ctrl.findPrimaryDriver();
            
            // TypeList code needs to be changed
            if(primaryDriver.maritialStatus != "M"){
                return true;
            }
            
            var drivers = submissionVm.value.draftData.lobs.personalAuto.drivers;
            var spouseFound = false;
            
            for (var idx in drivers){
                var driver = drivers[idx];
                //console.log("driver.relationShip:: ",driver.relationShip);
                if(driver.relationShip == "Spouse"){
                    spouseFound = true;
                }
            }
            
            return spouseFound;
        };

        // DFCT0022696: Marital status on SC Renewal flipped from married to single: Rate bearing issue--Arpita
        ctrl.validAdditionalDriverdRel = function(){
            let primaryDriver = ctrl.findPrimaryDriver();
            let validrel = true;
            let drivers = submissionVm.value.draftData.lobs.personalAuto.drivers;
                
            for (let idx in drivers){
                let driver = drivers[idx];                
                
                if(primaryDriver.maritialStatus == "S" && driver.relationShip == "Spouse") {
                    //if named insured has a marital status single and additional driver who is selected as spouse of named insured has a marital status married or single don't allow user to move to next screen
                    if(driver.maritialStatus == "M" || driver.maritialStatus == "S"){
                        validrel = false;
                    }
                }
                //if named insured has a marital status married and additional driver who is selected as spouse of named insured has a marital status single don't allow user to move to next screen
                if(primaryDriver.maritialStatus == "M"){
                    if(driver.maritialStatus == "S" && driver.relationShip == "Spouse"){
                        validrel = false;
                    }
                }
            }

            return validrel;
        }//end

        ctrl.next = function (form) {
            
            form.submitted = true;  
            
            //console.log("Driver Screen Form:: ",form);
            
            if (!ctrl._isValid() || form.valid === false) {
                return;
            }            
            
            var spouseValidStatus = ctrl.validateSpouse();
            // if spouse not found not allow user to move to next screen
            if (spouseValidStatus === false){
                ModalService.showWarning('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Relationship to you message");
                return;
            }
            
            // DFCT0022696: Marital status on SC Renewal flipped from married to single: Rate bearing issue--Arpita
            var validAddDriverRel = ctrl.validAdditionalDriverdRel();
            if(validAddDriverRel === false){
                ModalService.showWarning('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Relationship to you message");
                return;
            }

            // Check all driver are valid
            /*for(var idx in $scope.page.drivers){
                var driver = $scope.page.drivers[idx];
                console.log("Check Valid Driver: ",driver);
                if(driver.aspects.subtreeValid == false){
                    console.log("Invalid Driver:: ",driver.value);
                }
            }  */

            
            // Enable this line if want to validate all drivers form vaild status
            if(!submissionVm.draftData.lobs.personalAuto.drivers.aspects.subtreeValid){
                ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Driver Validation Error");
                return;
            }
            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
            let isDobEmpty = false
            let isDOBValid = true
            var drivers = submissionVm.draftData.lobs.personalAuto.drivers.value;
            if(typeof drivers != 'undefined' && drivers.length > 0){
                _.forEach(drivers,function(item,index){
                    if(item && !item.dateOfBirth){
                        ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Driver Validation Error");
                        isDobEmpty = true
                    }
                    if(item.dateOfBirth && item.dateOfBirth.year && (item.dateOfBirth.year < "1800")){
                        item.dateOfBirth.value = '';
                        isDOBValid = false;
                        return;
                    }
                    //ENHC0013007 -- Insurance Premium Refunds --Arpita
                    let inputsToValidate = [
                        {'firstName' : item.person.firstName},
                        {'middleName' : item.person.middleName},
                        {'lastName' : item.person.lastName}
                    ];
                    validateInputs(inputsToValidate, item.person)
                    //ended
                });
                if(!$scope.isNameValid){
                    return
                }
                if(isDobEmpty || !isDOBValid){
                    return;
                }
                //ENHC0013007 -- Insurance Premium Refunds --Arpita
                if(!$scope.isNameValid){
                    return;
                }//ended
            }
            //DFCT0020397 - QnB Date Of Birth Validation ends
            
            flowModel.next(submissionVm);
        };
        ctrl.previous = function () {
            flowModel.previous(submissionVm);
        };
        ctrl.cancel = function () {
            flowModel.cancel(submissionVm);
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['$filter', '$scope', '$rootScope', '$translate', '$anchorScroll', 'ModalService', 'StateUtils', 'submissionViewModel','InMemorySession','qnb.InputValidationService'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/controllers/PADriverDetailsCtrl.js
 **/